<template>
<div>
    <!-- modal -->
    <b-modal id="plantVarietyAnnuityFormModal" centered size="lg" no-close-on-backdrop :cancel-title=" $t('others.cancel_title')" :ok-title=" $t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate" ref="plantVarietyAnnuityFormModal" :title="$t('plantVarietyAnnuity.info')" @close="clear()">
        <validation-observer ref="infoRules" tag="form">
            <b-row>
                <b-col class="col-md-4 mt-1">
                    <b-form>
                        <validation-provider #default="{ errors }" :name="$t('plantVarietyAnnuity.year')" :rules="{ excluded: 0 }">
                            <label for="plantVariety-annuity-year-input">{{ $t('plantVarietyAnnuity.year') }}</label>
                            <b-form-select v-model="yearSelect" value-field="id" text-field="name" size="sm" :options="yearOption" />
                            <b-form-invalid-feedback :state="errors.length > 0 ? false : null">
                                {{ errors[0] }}
                            </b-form-invalid-feedback>
                        </validation-provider>
                    </b-form>
                </b-col>
                <b-col class="col-md-4 mt-1">
                    <label for="plantVariety-annuity-date-input">{{ $t('plantVarietyAnnuity.date') }}</label>
                    <CustomDatePicker :datePickerValidateOption="1" v-model="date"></CustomDatePicker>
                </b-col>
                <b-col class="col-md-4 mt-1">
                    <label for="plantVariety-annuity-payment-date-input">{{ $t('plantVarietyAnnuity.payment_date') }}</label>
                    <CustomDatePicker :datePickerValidateOption="0" v-model="paymentDate"></CustomDatePicker>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-md-4 mt-1">
                    <label for="plantVariety-annuity-installment-deadline-date-input">{{ $t('plantVarietyAnnuity.installment_payment_deadline_date') }}</label>
                    <CustomDatePicker :datePickerValidateOption="0" v-model="installmentPaymentDeadlineDate"></CustomDatePicker>
                </b-col>
                <b-col class="col-md-4 mt-1">
                    <b-form>
                        <validation-provider :name="$t('plantVarietyAnnuity.will_pay')" #default="{ errors }" :rules="{ excluded: 0 }">
                            <label for="language-input">{{ $t('plantVarietyAnnuity.will_pay') }}</label>
                            <b-form-select v-model="plantVarietyAnnuityWillPaySelect" value-field="id" text-field="name" size="sm" :options="plantVarietyAnnuityWillPayOption" />
                            <b-form-invalid-feedback :state="errors.length > 0 ? false : null">
                                {{ errors[0] }}
                            </b-form-invalid-feedback>
                        </validation-provider>
                    </b-form>
                </b-col>
                <b-col class="col-md-4 mt-1">
                    <b-form>
                        <label for="language-input">{{ $t('plantVarietyAnnuity.status') }}</label>
                        <b-form-select v-model="plantVarietyAnnuityStatusSelect" value-field="id" size="sm" text-field="name" :options="plantVarietyAnnuityStatusOption" />
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-md-12 mt-1">
                    <label for="textarea-default">{{ $t('plantVarietyAnnuity.explanation') }}</label>
                    <b-form-textarea id="textarea-default" :placeholder="$t('plantVarietyAnnuity.explanation')" v-model="explanation" rows="6" maxlength="150" />
                </b-col>
            </b-row>
        </validation-observer>
    </b-modal>
</div>
</template>

<script>
export default {
    watch: {
        installmentDeadlineDate(newValue) {
            if (newValue == '') {
                this.installmentDeadlineDate = null
            }
        },
        paymentDate(newValue) {
            if (newValue == '') {
                this.paymentDate = null
            }
        },
    },
    props: {
        getPlantVarietyAnnuityList: {
            type: Function
        },
        getPlantVarietyList: {
            type: Function
        },
        item: {
            type: Number
        }
    },
    data() {
        return {
            id: 0,
            plantVarietyId: 0,
            yearOption: [],
            yearSelect: 0,
            plantVarietyAnnuityWillPayOption: [],
            plantVarietyAnnuityWillPaySelect: 0,
            date: null,
            paymentDate: null,
            plantVarietyAnnuityStatusSelect: 0,
            plantVarietyAnnuityStatusOption: [],
            explanation: '',
            installmentPaymentDeadlineDate: null
        }
    },
    methods: {
        showInfo(id, plantVarietyId) {
            this.$refs['plantVarietyAnnuityFormModal'].show()
            this.id = id
            this.plantVarietyId = plantVarietyId
            const data = {
                id: this.id,
                plantVarietyId: this.plantVarietyId
            }
            const controller = {
                name: 'PlantVarietyAnnuity'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.yearSelect = response.data.plantVarietyAnnuity.year
                    this.yearOption = response.data.plantVarietyAnnuityYearList
                    this.plantVarietyAnnuityWillPaySelect = response.data.plantVarietyAnnuity.plantVarietyAnnuityWillPayId
                    this.plantVarietyAnnuityWillPayOption = response.data.plantVarietyAnnuityWillPayList
                    this.date = response.data.plantVarietyAnnuity.date
                    this.plantVarietyAnnuityStatusSelect = response.data.plantVarietyAnnuity.plantVarietyAnnuityStatusId
                    this.plantVarietyAnnuityStatusOption = response.data.plantVarietyAnnuityStatusList
                    this.paymentDate = response.data.plantVarietyAnnuity.paymentDate
                    this.explanation = response.data.plantVarietyAnnuity.explanation
                    this.installmentPaymentDeadlineDate = response.data.plantVarietyAnnuity.installmentPaymentDeadlineDate
                    this.plantVarietyAnnuityWillPayOption.splice(0, 0, this.$nullSelected('name'))
                    this.plantVarietyAnnuityStatusOption.splice(0, 0, this.$nullSelected('name'))
                } else {
                    this.$bvModal.hide('plantVarietyAnnuityFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        clear() {
            this.translatorSelect = 0
            this.languageSelect = 0
        },
        addOrUpdate() {
            const data = {
                id: this.id,
                plantVarietyId: this.plantVarietyId,
                year: this.yearSelect,
                plantVarietyAnnuityWillPayId: this.plantVarietyAnnuityWillPaySelect,
                date: this.date,
                plantVarietyAnnuityStatusId: this.plantVarietyAnnuityStatusSelect,
                paymentDate: this.paymentDate,
                explanation: this.explanation,
                installmentPaymentDeadlineDate: this.installmentPaymentDeadlineDate
            }
            const controller = {
                name: 'PlantVarietyAnnuity'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$refs.infoRules.validate().then(success => {
                if (success) {
                    this.$store.dispatch('moduleAuth/save', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.$bvModal.hide('plantVarietyAnnuityFormModal')
                            this.getPlantVarietyAnnuityList()
                            this.$SaveAlert()
                            this.getPlantVarietyList()
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                        }
                    })
                }
            })
        },
    },
}
</script>

<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}

.customList {
    border: 1px solid #999;
    padding: 20px;
}

.datepickerStyle {
    max-height: 2.2em;
    font-family: fangsong;
}
</style>
